"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDynamicFormFieldValue = void 0;
const SaveCooperationAgreementInputDynamicForm_1 = require("../types/SaveCooperationAgreementInputDynamicForm");
const isCountryField = (field) => {
    return SaveCooperationAgreementInputDynamicForm_1.DynamicFormConfigCountryFields.includes(field.fieldName);
};
const isMultiCountryField = (field) => {
    return SaveCooperationAgreementInputDynamicForm_1.DynamicFormConfigMultiCountryFields.includes(field.fieldName);
};
const getDynamicFormFieldValue = (field, countries) => {
    if (isCountryField(field)) {
        const countryId = field.value;
        return countries.find((country) => countryId === country._id)?.englishName ?? "";
    }
    if (isMultiCountryField(field)) {
        const countriesIds = field.value.split(",");
        return countriesIds
            .map((countryId) => countries.find((country) => countryId === country._id)?.englishName ?? "")
            .join(", ");
    }
    return field.value;
};
exports.getDynamicFormFieldValue = getDynamicFormFieldValue;
//# sourceMappingURL=getDynamicFormFieldValue.js.map